/**
 * Classes React Query Hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { classService } from '../services';

const CLASSES_KEY = 'classes';

export function useClasses(params = {}) {
  return useQuery({
    queryKey: [CLASSES_KEY, params],
    queryFn: () => classService.getAll(params),
    staleTime: 5 * 60 * 1000,
  });
}

export function useClass(id) {
  return useQuery({
    queryKey: [CLASSES_KEY, id],
    queryFn: () => classService.getById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreateClass() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: classService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CLASSES_KEY] });
    },
  });
}

export function useUpdateClass() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }) => classService.update(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [CLASSES_KEY] });
      queryClient.invalidateQueries({ queryKey: [CLASSES_KEY, variables.id] });
    },
  });
}

export function useDeleteClass() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: classService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CLASSES_KEY] });
    },
  });
}
